import type { ChartTheme } from '../types';

export function getChartTheme(isDark: boolean): ChartTheme {
  const chartTextColor = isDark ? '#d6d3d1' : '#44403c';
  const gridColor = isDark ? '#3b3836' : '#e7e5e4';
  return {
    chartTextColor,
    gridColor,
    tooltipStyle: {
      backgroundColor: isDark ? '#292524' : '#ffffff',
      border: `1px solid ${isDark ? '#3b3836' : '#e7e5e4'}`,
      borderRadius: '0.5rem',
      color: chartTextColor,
      fontSize: '0.8125rem',
    },
  };
}
